var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"todolistview"}},[_c('div',{staticClass:"three column centered grid"},[_c('div',{staticClass:"column"},[_c('todo-list',{attrs:{"todos":_vm.todos}}),_c('create-todo',{on:{"create-todo":_vm.createTodo}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }